module.exports = __webpack_public_path__ + "img/125ne.e5ca34c4.svg";